(function() {
	/*
	 * Fundly Campaign Widget
     *
     * Attributes:
     *  @fundlyurl - Fundly campaign URL
     * 
     * Usage: <fundly-campaign fundlyurl="s.fundlyurl"></fundly-campaign>
	 */
	SUGApp.directive('fundlyCampaign', [ '$sce', '$timeout', function ( $sce, $timeout ) {
		return {
			restrict: 'E',
            templateUrl: '/view/templates/ngtemplates/fundly-campaign.html',
			scope: {
                fundlyurl: '@'
            },
			link: function(scope, element, attrs) {

                // variables
                scope.iframesrc = '';
                scope.viewurl = '';
                var slug = '';
                // set text elements
                scope.str = {
                    poweredby:  'Powered by Fundly',
                    viewlink:   'View Campaign',
                };
				// this runs first
				function init(){
                    slug = getSlug();
                    scope.iframesrc = $sce.trustAsResourceUrl( getiFrameSrc() );
                    scope.viewurl = $sce.trustAsResourceUrl( getViewUrl() );
				}
                /**
                 * Parse slug from url. Url is like 'https://fundly.com/signupgenius-test-campaign'
                 */
                function getSlug(){
                    var url = angular.copy( scope.fundlyurl );
                    // parse out everything after the last /
                    return url.replace('https://fundly.com/','').replace('https://fundly.net/','');
                }
                /**
                 * Create iFrame source from slug
                 */
                function getiFrameSrc(){
                    return 'https://d2wwhrh9otv6z9.cloudfront.net/campaign_card_v2.html?activity=' + slug + '&amp;hb=t';
                }
                /**
                 * Create view link url from slug
                 */
                function getViewUrl(){
                    return scope.fundlyurl + '?ft_src=sug_campaign_card';
                }

                // fire init
				init();
            }
        };
    }]);

}());
